export const FORM_DATA_SAVED = 'FORM_DATA_SAVED';

export const formDataSaved = payload => dispatch =>
  dispatch({
    type: FORM_DATA_SAVED,
    payload,
  });
